import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function MallaSummary({ vigencia, faseCount, semestreCount, totals }) {
  return (
    <section className="course-detail__summary">
      <Container fluid>
        <Row className="g-3">
          <Col xs={6} md={3}>
            <div className="course-detail__summary__card">
              <span className="course-detail__summary__label">Vigencia</span>
              <strong className="course-detail__summary__value course-detail__summary__value--accent">
                {vigencia}
              </strong>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="course-detail__summary__card">
              <span className="course-detail__summary__label">Fases</span>
              <strong className="course-detail__summary__value">
                {faseCount}
              </strong>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="course-detail__summary__card">
              <span className="course-detail__summary__label">Semestres</span>
              <strong className="course-detail__summary__value">
                {semestreCount}
              </strong>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="course-detail__summary__card">
              <span className="course-detail__summary__label">
                Plan de estudios
              </span>
              <strong className="course-detail__summary__value">
                {totals.materias} materias
              </strong>
              <span className="course-detail__summary__meta">
                {Math.round(totals.creditos * 10) / 10} cr · {totals.horas} h
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default MallaSummary;
